module.exports = __webpack_public_path__ + "static/img/B03-沈阳私立实验学校.28f7c93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/B03-沈阳私立实验学校.png
// module id = SaVa
// module chunks = 0